module.exports = __webpack_public_path__ + "2bf3fb625d07e2f40d55687499c0745c.png";